import { MUIButton } from "@/components/core/material-ui";
import { IMAGE_BASE_PATH, PRODUCER_CODE_HARDCODE } from "@/config/config";
import { LOB, PAGE_ROUTES, PAGE_ROUTES_PA } from "@/config/constants";
import { removeReduxData } from "@/features/error/errorSlice";
import { setCustomerData } from "@/features/metadata/metadataSlice";
import { Box, Container, Stack, Typography, useTheme } from "@mui/material";
import Head from "next/head";
import { useRouter } from "next/router";
import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";

export default function Home() {
  const dispatch = useDispatch();
  const router = useRouter();
  const theme = useTheme();

  useEffect(() => {
    dispatch(removeReduxData());
  }, [dispatch]);

  const handleNewPolicyBuyClick = useCallback(() => {
    dispatch(removeReduxData());
    const additionalData = {
      branchLocation: "MUMBAI",
      locationCode: "90200",
      producerCode: PRODUCER_CODE_HARDCODE,
      channel: "Agency",
      banca: "",
      lob: LOB.HEALTH || "health",
    };
    dispatch(
      setCustomerData({
        intent: "BUY_POLICY",
        action: "edit",
        userType: "agent",
        ...additionalData,
      })
    );
    router.push(PAGE_ROUTES.MEMBERS);
  }, [dispatch, router]);

  const handleNewPolicyBuyClickPA = useCallback(() => {
    dispatch(removeReduxData());
    const additionalData = {
      branchLocation: "MUMBAI",
      locationCode: "90200",
      producerCode: PRODUCER_CODE_HARDCODE,
      channel: "Agency",
      banca: "",
      lob: LOB.PA || "pa",
    };
    dispatch(
      setCustomerData({
        intent: "BUY_POLICY",
        action: "edit",
        userType: "agent",
        ...additionalData,
      })
    );
    router.push(PAGE_ROUTES_PA.MEMBERS);
  }, [dispatch, router]);

  return (
    <>
      <Head>
        <title>Quick Quotes</title>
        <link rel="icon" href={`${IMAGE_BASE_PATH}/bolt-new-logo.svg`} />
      </Head>
      <Box
        component="main"
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: `linear-gradient(180deg, ${theme.palette.background.white} 0%, ${theme.palette.background.bubbles} 100%)`,
          padding: "2rem 1rem",
        }}
      >
        <Container maxWidth="md">
          <Stack
            spacing={4}
            alignItems="center"
            justifyContent="center"
            sx={{
              maxWidth: "600px",
              margin: "0 auto",
            }}
          >
            {/* Welcome Heading */}
            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: "1rem", sm: "2rem", md: "3rem" },
                fontWeight: 600,
                color: theme.palette.color.aigColor7,
                textAlign: "center",
                letterSpacing: "-0.03125rem",
                margin: 0,
              }}
            >
              Welcome to TATA AIG!
            </Typography>

            {/* Buttons Section */}
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={2}
              justifyContent="center"
              alignItems="center"
              sx={{
                width: "100%",
              }}
            >
              <MUIButton
                variant="aig-primary"
                type="button"
                onClick={() => {
                  handleNewPolicyBuyClick(false);
                }}
                sx={{
                  padding: { xs: "0.9rem 2rem", md: "1rem 2.5rem" },
                  fontSize: { xs: "1rem", md: "1.1rem" },
                  fontWeight: 600,
                  borderRadius: "3.125rem",
                  textTransform: "none",
                  width: "18rem",
                  transition: "all 0.3s ease",
                  boxShadow: `0 0.25rem 0.9375rem ${theme.palette.color.aigColor1}4d`,
                  "&:hover": {
                    transform: "translateY(-0.125rem)",
                    boxShadow: `0 0.375rem 1.25rem ${theme.palette.color.aigColor1}66`,
                  },
                  "&:active": {
                    transform: "translateY(0)",
                  },
                }}
              >
                Check Health Quote
              </MUIButton>

              <MUIButton
                variant="aig-primary"
                type="button"
                onClick={() => {
                  handleNewPolicyBuyClickPA(false);
                }}
                sx={{
                  padding: { xs: "0.9rem 2rem", md: "1rem 2.5rem" },
                  fontSize: { xs: "1rem", md: "1.1rem" },
                  fontWeight: 600,
                  borderRadius: "3.125rem",
                  textTransform: "none",
                  width: "18rem",
                  transition: "all 0.3s ease",
                  boxShadow: `0 0.25rem 0.9375rem ${theme.palette.color.aigColor1}4d`,
                  "&:hover": {
                    transform: "translateY(-0.125rem)",
                    boxShadow: `0 0.375rem 1.25rem ${theme.palette.color.aigColor1}66`,
                  },
                  "&:active": {
                    transform: "translateY(0)",
                  },
                }}
              >
                Check PA Quote
              </MUIButton>
            </Stack>
          </Stack>
        </Container>
      </Box>
    </>
  );
}
